import React, { useState } from 'react';
import styled from 'styled-components';

const Root = styled.div`
    position: fixed;
    bottom: 24px;
    right: 24px;
    z-index: 999999;
    font-family: sans-serif;
`;

const ToggleButton = styled.button`
    width: 60px;
    height: 60px;
    border: 2px solid #000;
    background: transparent;
    background-image: url('/assets/logo-black-outline-500.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    color: #000;
    cursor: pointer;
    box-shadow: none;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s;

    &:hover {
        transform: scale(1.08);
    }

    &:focus-visible {
        outline: 2px solid #000;
        outline-offset: 2px;
    }
`;

const Frame = styled.iframe`
    display: ${(p) => (p.$open ? 'block' : 'none')};
    position: absolute;
    bottom: 70px;
    right: 0;
    width: 420px;
    height: 600px;
    max-height: 80vh;
    background: transparent;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
    border: none;
    border-radius: 16px;
`;

const ChatbotWidget = ({ slug = 'synaptek-annecy' }) => {
    const [open, setOpen] = useState(false);
    const base = typeof window !== 'undefined' ? window.location.origin : '';
    const iframeSrc = `${base}/chatbot/${encodeURIComponent(slug)}`;

    return (
        <Root id="synaptek-chatbot-root">
            <ToggleButton
                type="button"
                aria-label={open ? 'Fermer le chat' : 'Ouvrir le chat'}
                onClick={() => setOpen((o) => !o)}
            >
                {/* <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    aria-hidden
                >
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg> */}
            </ToggleButton>
            <Frame
                src={iframeSrc}
                title="Chatbot"
                $open={open}
            />
        </Root>
    );
};

export default ChatbotWidget;
